import { useEffect, useState } from "react";
import styles from "../../../styles/components/PrivacyDataSection.module.css";
import { accountsService } from "../../../services/accounts.service";

export default function PrivacyDataSection({ accounts = [] }) {
    const adminRootAccounts = accounts.filter((account) => account.father_account == null);
    const [selectedId, setSelectedId] = useState(adminRootAccounts[0]?.id ?? "");
    const [sharingEnabled, setSharingEnabled] = useState(false);
    const [confirmDisable, setConfirmDisable] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const selectedAccount = adminRootAccounts.find((account) => String(account.id) === String(selectedId));
    const selectedAccountSharingEnabled = Boolean(selectedAccount && !selectedAccount.private_prospecting_data);

    useEffect(() => {
        if (!adminRootAccounts.some((account) => String(account.id) === String(selectedId))) {
            setSelectedId(adminRootAccounts[0]?.id ?? "");
        }
    }, [adminRootAccounts, selectedId]);

    useEffect(() => {
        setSharingEnabled(selectedAccountSharingEnabled);
        setError("");
    }, [selectedAccount?.id, selectedAccountSharingEnabled]);

    const saveSharingPreference = async (enabled) => {
        if (!selectedAccount) return;
        setSaving(true);
        setError("");
        try {
            await accountsService.update(selectedAccount.id, { private_prospecting_data: !enabled });
            setSharingEnabled(enabled);
            setConfirmDisable(false);
        } catch (requestError) {
            setError(requestError?.response?.data?.detail || "No se pudo actualizar la preferencia.");
        } finally {
            setSaving(false);
        }
    };

    const handleToggle = () => {
        if (sharingEnabled) {
            setConfirmDisable(true);
            return;
        }
        saveSharingPreference(true);
    };

    return (
        <section className={styles.section}>
            <h3 className={styles.heading}>Privacidad de datos</h3>
            {adminRootAccounts.length === 0 ? (
                <p className={styles.description}>Solo un administrador de cuenta puede cambiar esta preferencia.</p>
            ) : (
                <>
                    {adminRootAccounts.length > 1 && (
                        <label className={styles.accountSelect}>
                            <span>Cuenta</span>
                            <select value={selectedId} onChange={(event) => setSelectedId(event.target.value)}>
                                {adminRootAccounts.map((account) => (
                                    <option key={account.id} value={account.id}>{account.name || `Cuenta ${account.id}`}</option>
                                ))}
                            </select>
                        </label>
                    )}
                    {selectedAccount && (
                        <div className={styles.preferenceRow}>
                            <div>
                                <div className={styles.preferenceTitle}>Compartir contactos verificados</div>
                                <p className={styles.description}>Los contactos de esta cuenta pueden incorporarse a la red de contactos verificados.</p>
                            </div>
                            <button
                                type="button"
                                role="switch"
                                aria-checked={sharingEnabled}
                                aria-label="Compartir contactos verificados"
                                className={`${styles.switch} ${sharingEnabled ? styles.switchOn : ""}`}
                                onClick={handleToggle}
                                disabled={saving}
                            >
                                <span />
                            </button>
                        </div>
                    )}
                    {error && <p className={styles.error} role="alert">{error}</p>}
                </>
            )}
            {confirmDisable && (
                <div className={styles.backdrop}>
                    <section className={styles.dialog} role="dialog" aria-modal="true" aria-labelledby="privacy-confirm-title">
                        <h4 id="privacy-confirm-title">¿Desactivar el uso compartido?</h4>
                        <p>Los contactos de esta cuenta dejarán de incorporarse a la red. Confirmá para registrar el cambio.</p>
                        <div className={styles.actions}>
                            <button type="button" onClick={() => setConfirmDisable(false)} disabled={saving}>Cancelar</button>
                            <button type="button" onClick={() => saveSharingPreference(false)} disabled={saving}>
                                {saving ? "Guardando..." : "Desactivar"}
                            </button>
                        </div>
                    </section>
                </div>
            )}
        </section>
    );
}
